// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"5b31191332cac1d616cd","678":"58e46b62a32857a8d198","883":"08ad030942851fea14a0"}[chunkId] + ".js";
};